
const PseudoScrollControl = require('../viscomjs/pseudoScrollControl/PseudoScrollControl');
const ScrollDownArrow = require('./ScrollArrow');
const ScrollDownArrowControl = ScrollDownArrow(document.querySelector('.arrowdown-block'));
const settings = require('./ProjectScrollSettings');

const initScroll = (fltl, startAnimationDuration = 0) => {
    const body = document.body;
    const _updateScroll = fltl => {
        if (fltl.duration - fltl.t < 0.01)
            ScrollDownArrowControl.disable();
        else {
            ScrollDownArrowControl.enable();
            ScrollDownArrowControl.hide();
        }
        window.dispatchEvent(new window.Event('hideAlternativePicture'));

        body.dataset.firstScroll = 1;
    }

    const adapter = {
        startAnimationDuration: startAnimationDuration,
        setState: state => {
            switch (state) {
                case 'short':
                    adapter.increment = adapter.moveShort;
                    break;
                case 'slowDown':
                    adapter.increment = adapter.moveAndSlowDown;
                    break;
                default:
                    adapter.increment = adapter.set;
                    break;
            }
        },
        getProgress: () => {
            return Math.max(0, (fltl.realT - startAnimationDuration) / (fltl.duration - startAnimationDuration));
        },
        set: value => {
            fltl.transition = 0;
            const t = fltl.t + value;
            fltl.t = t < startAnimationDuration ? startAnimationDuration : t;
            _updateScroll(fltl);
        },
        moveShort: value => {
            fltl.transition = settings.shortDuration;
            const t = fltl.t + value;
            fltl.playToT(t < startAnimationDuration ? startAnimationDuration : t);
            _updateScroll(fltl);
        },
        moveAndSlowDown: value => {
            fltl.transition = settings.slowDownDuration;
            const t = fltl.t + value;
            fltl.playToT(t < startAnimationDuration ? startAnimationDuration : t);
            _updateScroll(fltl);
        },
        increment: null
    };
    adapter.setState();
    ScrollDownArrowControl.show();

    return PseudoScrollControl(adapter, settings.params);
};

module.exports = initScroll;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/ProjectScrollControl.js